import React, { useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import { GlobalWorkerOptions } from "pdfjs-dist/build/pdf";
import Papa from "papaparse";
import axios from 'axios';


// pdf.js worker
import pdfWorker from "./PdfWorker.js";
GlobalWorkerOptions.workerSrc = pdfWorker;

// NEW: create PDF
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function Pdf() {
  const [tables, setTables] = useState([]); // raw tables per page (array of arrays)
  const [structured, setStructured] = useState([]); // parsed structured rows per page
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // --- helpers ---
  const cleanNumber = (val) => {
    if (val == null) return 0;
    const s = String(val).replace(/[^0-9.\-]/g, "");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };

  const toCurrency = (n) =>
    (n ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const memory = [ {name: "128GB"}, {name: "16GB"}, {name: "1TB"}, {name: "256GB"}, {name: "2TB"}, {name: "32GB"}, {name: "512GB"}, {name: "64GB"}, {name: "8GB"} ];
  const color = [
  { name: "ALPINE GREEN" },   { name: "ASH" },   { name: "AURA RED" },   { name: "BLACK" },   { name: "BLACK TITANIUM" },
  { name: "BLUE" },  { name: "BLUE TITANIUM" },   { name: "CLOUD NAVY" },   { name: "CORAL" },   { name: "COSMIC GREY" },
  { name: "DEEP PURPLE" }, { name: "GOLD" }, { name: "GRAPHITE" }, { name: "GREEN" }, { name: "GREY" }, { name: "JET BLACK" },
  { name: "MIDNIGHT" }, { name: "MIDNIGHT GREEN" }, { name: "MOCHA" }, { name: "NATURAL TITANIUM" }, { name: "PACIFIC BLUE" },
  { name: "PRISM BLUE" }, { name: "PURPLE" }, { name: "RED" }, { name: "ROSE GOLD" }, { name: "SIERRA BLUE" }, { name: "SILVER" },
  { name: "Space Gray" }, { name: "SPACE GREY" }, { name: "SPACEGREY" }, { name: "STARLIGHT" }, { name: "STARLIGHT" },
  { name: "WHITE" }, { name: "WHITE TITANIUM" }, { name: "YELLOW" }];

  const category = [
  { name: "HUAWEI P20" },   { name: "iPad 5th" },  { name: "IPAD 6TH GEN" }, { name: "IPAD 6TH GEN" }, { name: "IPAD 7TH GEN" },
  { name: "IPAD 8TH GEN" }, { name: "IPAD 9TH GEN" }, { name: "iPad Air" }, { name: "iPad Air 2" },  { name: "iPad Air 3" },
  { name: "iPad mini 2" },   { name: "IPAD PRO (3ND GEN)" },   { name: "IPAD PRO 11\" (4TH GEN)" },   { name: "IPAD PRO 12.9\"(2ND GEN)" },   { name: "IPHONE 11" },  { name: "IPHONE 11 PRO" },  { name: "IPHONE 11 PRO MAX" },  { name: "IPHONE 12" },
  { name: "IPHONE 12 PRO" },  { name: "IPHONE 12 PRO MAX" },  { name: "IPHONE 12MINI" },  { name: "IPHONE 13" },  { name: "IPHONE 13 PRO" },  { name: "Iphone 13 Pro" },   { name: "IPHONE 13 Pro" },   { name: "IPHONE 13 PRO MAX" },
  { name: "IPHONE 13MINI" }, { name: "IPHONE 14" }, { name: "IPHONE 14 PRO" }, { name: "IPHONE 14 PRO MAX" }, { name: "IPHONE 15" }, { name: "IPHONE 15 PLUS" }, { name: "IPHONE 15 PRO MAX" }, { name: "IPHONE 4S" }, { name: "IPHONE 5" }, { name: "IPHONE 5C" }, { name: "IPHONE 5S" }, { name: "Iphone 5s" }, { name: "IPHONE 5SE" }, { name: "IPHONE 6" }, { name: "IPHONE 6PLUS" },
  { name: "IPHONE 6S" }, { name: "IPHONE 6S PLUS" }, { name: "IPHONE 7" }, { name: "IPHONE 7 PLUS" }, { name: "IPHONE 8" },
  { name: "IPHONE 8 PLUS" }, { name: "IPHONE 8PLUS" }, { name: "IPHONE SE 2020" }, { name: "IPHONE SE 2020" }, { name: "IPHONE SE 2022" }, { name: "IPHONE SE 3RD GEN" }, { name: "IPHONE X" }, { name: "IPHONE XR" }, { name: "IPHONE XS" }, { name: "IPHONE XS MAX" }, { name: "Macbook pro 2015" }, { name: "SAMSUNG A3" }, { name: "SAMSUNG A32" }, { name: "SAMSUNG A33" }, { name: "SAMSUNG A40" }, { name: "SAMSUNG A5" }, { name: "SAMSUNG A5 2016" }, { name: "SAMSUNG A50" }, { name: "SAMSUNG A51" },
  { name: "SAMSUNG A6" }, { name: "SAMSUNG A7" }, { name: "SAMSUNG A8" }, { name: "SAMSUNG GALAXY A12" }, { name: "SAMSUNG GALAXY A13" }, { name: "SAMSUNG GALAXY A20E" }, { name: "SAMSUNG GALAXY A21S" }, { name: "SAMSUNG GALAXY A22" }, { name: "SAMSUNG GALAXY A3" }, { name: "SAMSUNG GALAXY A3" }, { name: "SAMSUNG GALAXY A40" }, { name: "SAMSUNG GALAXY A5" }, { name: "SAMSUNG GALAXY A51" }, { name: "SAMSUNG GALAXY A6" }, { name: "SAMSUNG GALAXY A70" }, { name: "SAMSUNG GALAXY A71" }, { name: "SAMSUNG GALAXY ACE STYLE" }, { name: "SAMSUNG GALAXY FOLD 3" }, { name: "SAMSUNG GALAXY J3" }, { name: "SAMSUNG GALAXY J4 PLUS" },
  { name: "SAMSUNG GALAXY J5" }, { name: "SAMSUNG GALAXY J5 PLUS" }, { name: "SAMSUNG GALAXY NOTE 10 PLUS" }, { name: "SAMSUNG GALAXY S10" }, { name: "SAMSUNG GALAXY S10 PLUS" }, { name: "SAMSUNG GALAXY S10E" }, { name: "SAMSUNG GALAXY S21" },
  { name: "SAMSUNG GALAXY S22" }, { name: "SAMSUNG GALAXY S4MINI" }, { name: "SAMSUNG GALAXY S5" }, { name: "SAMSUNG GALAXY S5MINI" }, { name: "SAMSUNG GALAXY S6" }, { name: "SAMSUNG GALAXY S9" }, { name: "SAMSUNG GALAXY S9 PLUS" }, { name: "SAMSUNG GALAXY TAB A" }, { name: "SAMSUNG GALAXY TAB A" }, { name: "SAMSUNG GALAXY TAB A7 LITE" }, { name: "SAMSUNG GALAXY TAB A9 PLUS 5G" }, { name: "SAMSUNG GALAXY TAB B" }, { name: "SAMSUNG GALAXY XCOVER3" }, { name: "SAMSUNG GALAXY XCOVER4" }, { name: "SAMSUNG NOTE 8" }, { name: "SAMSUNG S10E" }, { name: "SAMSUNG S22 ULTRA" }, { name: "SAMSUNG S4" }, { name: "SAMSUNG S5 MINI" }, { name: "SAMSUNG S6 EDGE" }, { name: "SAMSUNG S7" }, { name: "SAMSUNG S7 EDGE" }, { name: "SAMSUNG S8" },
  { name: "SAMSUNG TAB A" }, { name: "SAMSUNG TAB A8" }, { name: "SAMSUNG TAB B" }, { name: "SAMSUNG XCOVER 4" }, { name: "SE 2022" }
];



  // Try to locate header indices for important columns
  const detectHeader = (row) => {
    const headers = row.map((c) => c.toLowerCase().trim());
    const idx = {
      sn: headers.findIndex((h) => /^(s\/?n|no\.?|#)$/.test(h)),
      description: headers.findIndex((h) => /(description|product|item|name)/.test(h)),
      qty: headers.findIndex((h) => /(unit|qty|quantity)/.test(h)),
      unitPrice: headers.findIndex((h) => /(sale\s*price|price)/.test(h)),
      lineTotal: headers.findIndex((h) => /(line\s*total|total)/.test(h)),
    };
    // ensure distinctness / minimal validity
    if (idx.description === -1 || idx.qty === -1 || (idx.unitPrice === -1 && idx.lineTotal === -1)) {
      return null;
    }
    return idx;
  };

  
const tableToStructured = (table) => {
  if (!table || table.length === 0) return [];

  console.log("🔍 Table (raw):", table);

  // Try to detect headers (your existing logic)
  let headerIdx = -1;
  let map = null;
  for (let i = 0; i < Math.min(table.length, 10); i++) {
    map = detectHeader(table[i]);
    if (map) {
      headerIdx = i;
      break;
    }
  }

  const findMatch = (desc, arr) => {
    if (!desc) return null;
    const descLower = desc.toLowerCase();
    const sortedArr = [...arr].sort((a, b) => b.name.length - a.name.length);
    for (const item of sortedArr) {
      if (descLower.includes(item.name.toLowerCase())) {
        return item.name;
      }
    }
    return null;
  };


  // If no header is found, fallback to pattern matching
  if (headerIdx === -1 || !map) {
    console.warn("⚠️ Header not found. Using fallback...");

    const fallback = table
      .map((row) => {
        const line = row.join(" ").trim();

        const isNonItemLine = /(invoice|billing address|delivery address|order ref|account number|iban|registered office|goods total|carriage|total ex vat|total inc vat|grand total|vat number|company number|page \d+ of \d+|bank|sort code|swift|united kingdom|nigeria|staines rd|kingswood lakeside)/i;

        if (isNonItemLine.test(line)) return null;

        // Extract all numbers (both integer and decimal)
        const numbers = [...line.matchAll(/\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+/g)].map((m) => m[0]);

        if (numbers.length < 2) return null;

        const lineTotal = parseFloat(numbers[numbers.length - 1]) || 0;
        const qty = parseInt(numbers[numbers.length - 2]) || 0;

        let unitPrice = 0;
        if (qty && lineTotal) {
          unitPrice = +(lineTotal / qty).toFixed(2);
        } else if (numbers.length >= 3) {
          unitPrice = parseFloat(numbers[numbers.length - 3]) || 0;
        }

        // Add the new columns based on description match
        const colorMatch = findMatch(line, color);
        const categoryMatch = findMatch(line, category);
        const memoryMatch = findMatch(line, memory);

        return {
          description: line,
          qty,
          unitPrice,
          lineTotal,
          color: colorMatch,
          category: categoryMatch,
          memory: memoryMatch,
        };
      })
      .filter(Boolean);

    console.log("Fallback Result:", fallback);
    return fallback;
  }

  console.log("Header found at row", headerIdx, "→", map);
  const structuredRows = [];

  for (let i = headerIdx + 1; i < table.length; i++) {
    const row = table[i];
    if (!row || row.length === 0) continue;

    const description = row[map.description] ?? "";
    const qty = cleanNumber(row[map.qty]);
    const unitPrice = map.unitPrice !== -1 ? cleanNumber(row[map.unitPrice]) : 0;
    const lineTotal =
      map.lineTotal !== -1 ? cleanNumber(row[map.lineTotal]) : unitPrice * (qty || 0);

    const isDivider = row.every((c) => /^[-–—=]+$/.test(c || ""));
    if (isDivider) continue;

    if (!description || (!qty && !unitPrice && !lineTotal)) continue;

    // Add the new columns based on description match
    const colorMatch = findMatch(description, color);
    const categoryMatch = findMatch(description, category);
    const memoryMatch = findMatch(description, memory);

    structuredRows.push({
      description,
      qty,
      unitPrice,
      lineTotal,
      color: colorMatch,
      category: categoryMatch,
      memory: memoryMatch,
    });
  }

  console.log("Parsed Structured Rows:", structuredRows);
  return structuredRows;
};




  // Expand by quantity and re-calc totals
  const expandRows = (rows) => {
  return rows.flatMap((r, idx) => {
    const qty = Math.max(1, r.qty || 1);
    const unit = r.unitPrice || 0;
    const total = r.lineTotal || unit * qty;
    const perLine = total / qty;

    // Split the description into parts
    const fullDesc = r.description || "";
    const SKU = fullDesc.slice(0, 6).trim();
    const AssetTag = fullDesc.slice(6, 18).trim();
    const endOfDescription = fullDesc.indexOf("Grade C") + "Grade C".length;
    const trimmedDescription = fullDesc.slice(18, endOfDescription).trim();


    return Array.from({ length: qty }, (_, i) => ({
      SKU,
      AssetTag,
      Description: trimmedDescription,
      qty: qty,
      unitPrice: unit,
      lineTotal: perLine,
      color: r.color || "",
      category: r.category || "",
      memory: r.memory || "",
      _origIndex: idx,
      _splitIndex: i + 1,
    }));
  });
};



  

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    setError(null);
    setTables([]);
    setStructured([]);

    const reader = new FileReader();

    reader.onload = async function () {
      try {
        const typedarray = new Uint8Array(reader.result);
        const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;

        let extractedTables = [];
        let structuredPages = [];

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();

          // Group text items by rows (using y)
          let rowsByY = [];
          textContent.items.forEach((item) => {
            const { str, transform } = item;
            const y = transform[5];
            const x = transform[4];
            let row = rowsByY.find((r) => Math.abs(r.y - y) < 5);
            if (!row) {
              row = { y, cols: [] };
              rowsByY.push(row);
            }
            row.cols.push({ x, str });
          });

          // Sort rows top->bottom; flip if needed
          rowsByY.sort((a, b) => b.y - a.y);

          // Sort cols left->right and map to strings
          const table = rowsByY.map((row) => {
            row.cols.sort((a, b) => a.x - b.x);
            return row.cols.map((c) => c.str);
          });

          extractedTables.push(table);

          // Convert to structured rows and store
          const parsed = tableToStructured(table);
          structuredPages.push(parsed);
        }

        setTables(extractedTables);
        setStructured(structuredPages);
        console.log("Structured Pages", JSON.stringify(structuredPages, null, 2));

      } catch (err) {
        console.error("Error parsing PDF:", err);
        setError("Failed to parse PDF. Please try a different file.");
      } finally {
        setLoading(false);
      }
    };
    reader.readAsArrayBuffer(file);
  };



  const exportCSV = () => {
  if (structured.length === 0) return;

  const expandedAll = structured.flatMap((pageRows) =>
    expandRows(pageRows).map(({ SKU, AssetTag, Description, qty, unitPrice, lineTotal, color, category, memory }) => ({
      SKU,
      AssetTag,
      Description,
      Quantity: qty,
      "Unit Price": unitPrice,
      "Line Total": lineTotal,
      Color: color || "",
      Category: category || "",
      Memory: memory || "",
    }))
  );

  const csv = Papa.unparse(expandedAll);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "structured_export.csv";
  link.click();
  URL.revokeObjectURL(url);
};







  return (
    <div className="p-6 max-w-4xl mx-auto font-sans">
      <h1 className="text-2xl font-bold mb-4">PDF Table Extractor & Transformer</h1>

      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileUpload}
        className="mb-4 block"
      />

      {loading && <p className="text-blue-600">Loading PDF...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && structured.length > 0 && (
        <>
          <div className="mb-4 space-x-2">
            <button
              onClick={exportCSV}
              className="bg-gray-800 text-white px-4 py-2 rounded"
            >
              Download Raw CSV
            </button>
          </div>

          {structured.map((pageRows, p) => {
            const expanded = expandRows(pageRows);
            return (
              <div key={p} className="mb-6">
                <h3 className="font-semibold mb-2">Transformed (expanded) Table - Page {p + 1}</h3>
                <pre className="bg-gray-100 p-3 rounded overflow-x-auto text-sm">
                  {[
                    ["#", "SKU", "AssetTag", "Description", "Qty", "Unit Price", "Line Total"].join(" | "),
                    ...expanded.map((r, i) =>
                      [i + 1, r.SKU, r.AssetTag, r.Description, r.qty, toCurrency(r.unitPrice), toCurrency(r.lineTotal), r.category, r.memory, r.color].join(" | ")
                    ),
                  ].join("\n")}
                </pre>
              </div>
            );
          })}
        </>
      )}

    </div>
  );
}
